import './selectStakeholder.css';
import { useNavigate } from "react-router-dom";
import React, { useState, useEffect, useRef } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import TrashIcon from '../../../images/TrashIcon.png';
import { MDBSwitch } from 'mdb-react-ui-kit';
import { NOT_MAPPED, NO_DATA_AVAILABLE } from '../../../common/constants';
import { getMappedStakeholder, getStakeholdersBasedOnCriteria, getSelectedStakeholderDetails, DeleteDeactiveGrowerHitMapping, getAllStakeholdersBasedOnCriteria, submitGrowerHitStakeHolderMapping, checkMappingExists, validation_check_mapping } from './stakeholderMappingApi';
import { lastFiveDigitsComparator, titleCase } from '../../../common/commonFunction';
import { Button } from '@mui/material';
import { PROD } from '../../../common/constants';
import { Container, IconButton, Stack, Box, Typography, Grid, Card, CardContent, FormHelperText, FormControl, InputLabel, Select, MenuItem, TextField } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import CustomDataGridToolbar from '../../../common/customDataGridToolbar';
import { ConfirmationPopover } from '../../../common/commonPopovers/confirmationPopover';
import { toast } from 'react-toastify';
import DeleteIcon from '@mui/icons-material/Delete';
import { useTranslation } from 'react-i18next';
import { DataArraySharp } from '@mui/icons-material';
import { ProceedIcon } from '../../../common/icons';

function GrowerHitMapping() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [message, setMessage] = useState("");
  const [details, setDetails] = useState({
    rescAlreadyMappedStakeholder: '',
    resMappedName: '',
    resMappedURN: '',
    rescHitName: '',
    rescHitURN: '',
    revenueCircleVal: ''
  });
  const [errorMessage, setErrorMessage] = useState({
    choosestakeholderError: '',
    stakeholderlistError: '',
    hitNameError: '',
    checkedArrError: ''
  });
  const [updatedDetails, setUpdatedDetails] = useState({
    UpdatedTargetName: '',
    UpdatedTargetUrn: '',
    mappedItemId: '',
    growerUrn: '',
    inBetweenDistance: '',
    deactiveid: '',
    deleteid: '',
    deactivestatus: '',
    sourcestakeholderType: ''
  });
  const [filterTable, setFilterTable] = useState({
    urnNumber: '',
    name: '',
  });
  const [chooseMappedStakeholder, setchooseMappedStakeholder] = useState([]);
  const [selectedStakeHolderDetails, setSelectedStakeHolderDetails] = useState([]);
  const [getHitDetails, setGetHitDetails] = useState([]);
  const [getAllDetails, setGetAllDetails] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [searchFilteredResults, setSearchFilteredResults] = useState([]);
  const [showmappedTable, setShowmappedTable] = useState(false);
  const [showList, setShowList] = useState(false);
  const [showHITList, setShowHITList] = useState(false);
  const [showRevinueList, setShowRevinueList] = useState(false);
  const [removeitem, setRemoveitem] = useState(false);
  const [removeHititem, setRemoveHititem] = useState(false);
  const [logModalOpen, setLogModalOpen] = useState(false);
  const handleLogModalOpen = () => setLogModalOpen(true);
  const handleLogModalClose = () => setLogModalOpen(false);
  let [multipleGrowerHitMappingDetails, setMultipleGrowerHitMappingDetails] = useState([]);
  const [multipleSaveMappingData, setMultipleSaveMappingData] = useState([]);
  const userlog = useRef(true);
  const [logConfirmModalOpen, setLogConfirmModalOpen] = useState(false);
  const handleConfirmLogModalOpen = () => setLogConfirmModalOpen(true);
  const handleConfirmLogModalClose = () => setLogConfirmModalOpen(false);
  const [logConfirmModalOpenSubmit, setLogConfirmModalOpenSubmit] = useState(false);
  const handleConfirmLogModalOpenSubmit = () => setLogConfirmModalOpenSubmit(true);
  const handleConfirmLogModalCloseSubmit = () => setLogConfirmModalOpenSubmit(false);
  const [isSubmitApiCalled, setIsSubmitApiCalled] = useState(false);
  const [submit, setSubmit] = useState(false);
  useEffect(() => {
    if (userlog.current) {
      userlog.current = false;
      getMappedStakeholder(setchooseMappedStakeholder)
    }
  }, [userlog]);
  useEffect(() => {
    if (selectedStakeHolderDetails.length < 1) {
      setShowHITList(false)
      setShowRevinueList(false)
      setShowmappedTable(false)
      // setShowRevinueList(false)
    }
  }, [selectedStakeHolderDetails]);
  useEffect(() => {
    if ((details.resMappedName) && (details.resMappedURN)) {
      setShowHITList(true)
    }
  }, [details.resMappedName]);
  useEffect(() => {
    if (removeitem) {
      setDetails({
        ...details, resMappedName: '',
        resMappedURN: '',
        rescHitName: '',
        rescHitURN: '',
        revenueCircleVal: ''
      })
    }
  }, [removeitem]);

  useEffect(() => {
    if (removeHititem && (details.revenueCircleVal)) {
      setDetails({
        ...details,
        rescHitName: '',
        rescHitURN: '',
        revenueCircleVal: ''
      })
      setShowRevinueList(false)
      setShowmappedTable(false)
    }
    setRemoveHititem(false)
  }, [removeHititem]);
  useEffect(() => {
    if ((details.revenueCircleVal !== '') && (details.revenueCircleVal !== null)) {
      const filteredNameData = getAllDetails.filter((item) => {
        if (item.landDetailsOfGrowerResponsePojo[0].revenueCircle !== null) { return (item.landDetailsOfGrowerResponsePojo[0].revenueCircle.includes(details.revenueCircleVal.trim())) }
      })
      setFilteredResults(filteredNameData)
      if (filteredResults) {

        setShowmappedTable(true)
      }
    }
  }, [details.revenueCircleVal]);
  useEffect(() => {
    if (multipleSaveMappingData) {
      if (multipleSaveMappingData.status === 'SUCCESS') {
        toast.success(multipleSaveMappingData?.description);
        // navigate('/growerHitMapping')
      }
      else if (multipleSaveMappingData.status === 'FAILURE') {
        toast.error(multipleSaveMappingData?.description)
      }
      // setDetails({
      //   ...details, rescAlreadyMappedStakeholder: '', resMappedName: '',
      //   resMappedURN: '',
      //   rescHitName: '',
      //   rescHitURN: '',
      //   revenueCircleVal: ''
      // })
      // setUpdatedDetails('')
      // setFilterTable("")
      setMultipleGrowerHitMappingDetails([])
      // setShowList(false)
      // setShowmappedTable(false)
      // setShowHITList(false)
      // setShowRevinueList(false)
    }

  }, [multipleSaveMappingData]);
  const handleChange = (e) => {
    e.target.name && setDetails({ ...details, [e.target.name]: e.target.value })
    if (e.target.name === "rescAlreadyMappedStakeholder") {
      setShowHITList(false)
      setShowmappedTable(false)
      setShowRevinueList(false)
      if ((details.resMappedName) && (details.resMappedURN)) {
        setRemoveitem(true)
      }
      if ((details.rescHitName) && (details.rescHitURN)) {
        setRemoveitem(true)
      }
      if (details.revenueCircleVal) { setRemoveitem(true) }
      setDetails({ ...details, [e.target.name]: e.target.value })
      getSelectedStakeholderDetails(setSelectedStakeHolderDetails, "", "", e.target.value)
      if (selectedStakeHolderDetails) { setShowList(true) }
      setErrorMessage({ ...errorMessage, choosestakeholderError: " " });
    }
    if (e.target.name === "resMappedTypeName") {
      setRemoveitem(false)
      setRemoveHititem(true)
      let result_mapped_val = e.target.value.split("*")
      setDetails({ ...details, resMappedName: result_mapped_val[0], resMappedURN: result_mapped_val[1] });
      getStakeholdersBasedOnCriteria(details.rescAlreadyMappedStakeholder, result_mapped_val[1], 'HIT', setGetHitDetails)
      setErrorMessage({ ...errorMessage, stakeholderlistError: " " });
    }
    if (e.target.name === "selectHitName") {
      setRemoveitem(false)
      let result_hit_val = e.target.value.split("#")
      setDetails({ ...details, rescHitName: result_hit_val[0], rescHitURN: result_hit_val[1] });
      setErrorMessage({ ...errorMessage, hitNameError: " " });
    }
    if (e.target.name === "revenueCircleList") {
      setMultipleGrowerHitMappingDetails([])
      setRemoveitem(false)
      setDetails({ ...details, revenueCircleVal: e.target.value })

    }
  }
  const onSubmitStakeholder = (e) => {
    e.preventDefault();
    setSubmit(true)
    if ((details.rescAlreadyMappedStakeholder) && (details.rescHitName) && (details.rescHitURN) && (details.resMappedName) && (details.resMappedURN)) {
      getAllStakeholdersBasedOnCriteria(details.rescAlreadyMappedStakeholder, details.resMappedURN, 'Grower', setGetAllDetails)
      setShowRevinueList(true)
    }
    else {
      setShowRevinueList(false)
      if ((!details.rescHitName) && (!details.rescHitURN)) {
        setErrorMessage({ ...errorMessage, hitNameError: "Select HIT" });
      }
      if ((!details.resMappedName) && (!details.resMappedURN)) {
        setErrorMessage({ ...errorMessage, stakeholderlistError: "Select Name" });
      }
      if (!details.rescAlreadyMappedStakeholder) {
        setErrorMessage({ ...errorMessage, choosestakeholderError: "Select Mapped Stakeholder" });
      }
    }
  }
  const checkedGrower = (e, item, itemid, itemland) => {
    // e.preventDefault();
    let rowsArr = [...multipleGrowerHitMappingDetails]
    var index = rowsArr.map(e => e.sourceGrowerLandId).indexOf(itemid);
    if (index > -1) {
      rowsArr.splice(index, 1);
    } else {
      rowsArr.push(
        {
          sourceStakeholderType: "Grower",
          transporterUrn: "",
          route: "",
          sourceStakeholderUrn: item?.urn,
          targetStakeholderType: "Hit",
          targetStakeholderUrn: details?.rescHitURN,
          sourceGrowerLandId: itemland?.id,
          sourceStakeholderName: item?.stakeholderName,
          targetStakeholderName: details?.rescHitName,
          landName: itemland?.landName,
          transporterName: "",
          dependentStakeholderType: details?.rescAlreadyMappedStakeholder,
          dependentStakeholderUrn: details?.resMappedURN,
        });
      setErrorMessage({ ...errorMessage, checkedArrError: " " });
    }
    setMultipleGrowerHitMappingDetails(rowsArr);
  }

  const onConfirmCallBackSubmit = async () => {
 if (isSubmitApiCalled) return;              // prevent double tap
 setIsSubmitApiCalled(true);
 try {
   handleConfirmLogModalCloseSubmit();
   const requestData = multipleGrowerHitMappingDetails?.map(
     ({ mappedItemId, mappedStakeholderName, ...rest }) => rest
   );
   setFinalData(requestData);
   await validation_check_mapping(
     requestData,
     setMappingValidationCheck,
     true
   );
 } catch (error) {
   console.error("Submit API failed:", error);
 } finally {
   setIsSubmitApiCalled(false);              // unlock button
 }
};

  const [mappingValidationCheck, setMappingValidationCheck] = useState([]);
  console.log("mappingValidationCheck", mappingValidationCheck)
  const [finaldata, setFinalData] = useState();
  const [failedMappingArr, setFailedMappingArr] = useState();
  const [successMappingArr, setSuccessMappingArr] = useState();
  
  useEffect(() => {
    if (mappingValidationCheck.length > 0) {
      const failTempArr = [];
      const successTempArr = [];
      mappingValidationCheck?.map((item) => {
        if (item?.validationStatus?.status === "FAILURE") {

          const pushObject = multipleGrowerHitMappingDetails.find(findItem => ((findItem?.sourceGrowerLandId === item?.mapping?.sourceGrowerLandId)));
          failTempArr.push(pushObject);

        }
        if (mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {

          const pushObject = multipleGrowerHitMappingDetails.find(findItem => ((findItem?.sourceGrowerLandId === item?.mapping?.sourceGrowerLandId)));
          successTempArr.push(pushObject);

        }
      });
      setSuccessMappingArr(successTempArr)
      setFailedMappingArr(failTempArr);
      // if (!mappingValidationCheck?.every(item => item?.validationStatus?.status === "SUCCESS")) {
      //   toast.error("Mappings Marked In Red Are Pending For Approval")
      // }
    }
  }, [multipleGrowerHitMappingDetails, mappingValidationCheck, finaldata]);
  console.log("failedMappingArr", failedMappingArr)
  useEffect(() => {

    if (successMappingArr?.length > 0 && mappingValidationCheck) {
      submitGrowerHitStakeHolderMapping(finaldata, setMultipleSaveMappingData)
      setSuccessMappingArr()
      setMappingValidationCheck([])
    }
  }, [setMultipleSaveMappingData, successMappingArr, mappingValidationCheck, finaldata]);

  function onCancelBackSubmit() {
    handleConfirmLogModalCloseSubmit();
    setUpdatedDetails('');
  }

  const onSavedMappingStakeholder = (e) => {
    e.preventDefault();
    if (multipleGrowerHitMappingDetails.length > 0) {
      setErrorMessage({ ...errorMessage, checkedArrError: " " });
      setMappingValidationCheck([])
      handleConfirmLogModalOpenSubmit();
      // submitGrowerHitStakeHolderMapping(multipleGrowerHitMappingDetails, setMultipleSaveMappingData)
    }
    else {
      if (multipleGrowerHitMappingDetails.length === 0) {
        setErrorMessage({ ...errorMessage, checkedArrError: "Atleast Checked One Grower Details" });
      }
    }
  }
  const onDeactiveMapped = (e, item, landdetails) => {
    e.preventDefault();
    if (landdetails.isActive === 'N') {
      setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: landdetails?.targetStakeholderUrn, deactiveid: landdetails?.tableId, growerUrn: item?.urn, deactivestatus: "N" })
    }
    else {
      setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: landdetails?.targetStakeholderUrn, deactiveid: landdetails?.tableId, growerUrn: item?.urn, deactivestatus: "Y" })
    }
    const data = {
      "sourceStakeholderType": "Grower",
      "targetStakeholderType": "Hit",
      "sourceStakeholderUrn": item?.urn,
      "targetStakeholderUrn": landdetails?.targetStakeholderUrn,
      "transporterUrn": "",
      "transporterName": "",
      "route": "",
      "sourceGrowerLandId": updatedDetails.sourceGrowerLandId,
      "operation": (landdetails.isActive === "Y") ? "Deactivate" : "Activate",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };
  const onDeleteMappedTransporter = (e, item, landdetails) => {
    e.preventDefault();
    setUpdatedDetails({ ...updatedDetails, UpdatedTargetUrn: landdetails?.targetStakeholderUrn, deleteid: landdetails?.tableId, growerUrn: item?.urn, deactivestatus: "N" })
    const data = {
      "sourceStakeholderType": "Grower",
      "targetStakeholderType": "Hit",
      "sourceStakeholderUrn": item?.urn,
      "targetStakeholderUrn": landdetails?.targetStakeholderUrn,
      "transporterUrn": "",
      "transporterName": "",
      "route": "",
      "sourceGrowerLandId": updatedDetails.sourceGrowerLandId,
      "operation": "Delete",
    }
    checkMappingExists(data, handleConfirmLogModalOpen, setMessage);
    // handleConfirmLogModalOpen();
  };
  function onConfirmCallBack() {
    handleConfirmLogModalClose();
    if ((updatedDetails.deactiveid) || (updatedDetails.deleteid)) {
      DeleteDeactiveGrowerHitMapping(updatedDetails, setMultipleSaveMappingData, details, setGetAllDetails)
    }
  }
  function onCancelBack() {
    handleConfirmLogModalClose();
    setUpdatedDetails('');
  }
  const growerhitmapping = [
    {
      field: 'checkbox', headerName: ' ', width: 50,
      renderCell: (params) => {
        return (
          (params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMapped === false) ?
            <input type="checkbox" name="chekedGrower" checked={multipleGrowerHitMappingDetails && multipleGrowerHitMappingDetails?.find(mappedcheckbox => mappedcheckbox?.sourceGrowerLandId === params?.row?.landDetailsOfGrowerResponsePojo[0]?.id) ? true : false} onChange={(e) => checkedGrower(e, params?.row, params?.row?.landDetailsOfGrowerResponsePojo[0]?.id, params?.row?.landDetailsOfGrowerResponsePojo[0])} />
            :
            <></>
        )
      }
    },
    {
      field: 'stakeholderName', headerName: t('preReg.name'), width: 150,
      renderCell: (params) => (
        <Typography>{params?.row?.stakeholderName && titleCase(params?.row?.stakeholderName)}</Typography>
      )
    },
    { field: 'urn', headerName: 'URN', width: 150, sortComparator: (a, b) => lastFiveDigitsComparator(a, b) },
    {
      field: 'revenueCircle', headerName: 'Revenue circle/Block', width: 180,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.revenueCircle
      },
      renderCell: (params) => (
        <Typography>{params?.row?.landDetailsOfGrowerResponsePojo[0]?.revenueCircle}</Typography>
      )
    },
    {
      field: 'landName', headerName: 'Land Name', width: 150,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.landName
      },
      renderCell: (params) => (
        <Typography>{params?.row?.landDetailsOfGrowerResponsePojo[0]?.landName && titleCase(params?.row?.landDetailsOfGrowerResponsePojo[0]?.landName)}</Typography>
      )
    },
    {
      field: 'landMappedWith', headerName: 'HIT Name', width: 150,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMappedWith
      },
      renderCell: (params) => (
        <Typography>{params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMappedWith && titleCase(params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMappedWith)}</Typography>
      )
    },
    {
      field: 'targetStakeholderUrn', headerName: 'HIT URN', width: 150,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.targetStakeholderUrn
      },
      renderCell: (params) => (
        <Typography>{params?.row?.landDetailsOfGrowerResponsePojo[0]?.targetStakeholderUrn}</Typography>
      )
    },
    {
      field: 'action', headerName: 'Activate/Deactivate', width: 150,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMapped === false ?
          NOT_MAPPED
          :
          params?.row?.landDetailsOfGrowerResponsePojo[0]?.isActive === 'N' ? "Deactivated" : "Activated"
      },
      renderCell: (params) => {
        return (

          (params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMapped === false) ?
            <Typography>{NOT_MAPPED}</Typography>
            :
            <MDBSwitch className='RescDeactiveSwitch' disabled={params?.row?.landDetailsOfGrowerResponsePojo[0]?.sendForDeleteDeactivate === "Y"} checked={params?.row?.landDetailsOfGrowerResponsePojo[0]?.isActive === 'N' ? false : true} onClick={(e) => onDeactiveMapped(e, params?.row, params?.row?.landDetailsOfGrowerResponsePojo[0])} id='flexSwitchCheckChecked' />
        )
      }
    },
    {
      field: 'deleteaction', headerName: 'Delete', width: 120,
      valueGetter: (params) => {
        return params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMapped === false ?
          NOT_MAPPED
          :
          "Delete"
      },
      renderCell: (params) => {
        return (
          (params?.row?.landDetailsOfGrowerResponsePojo[0]?.landMapped === false) ?
            <Typography>{NOT_MAPPED}</Typography>
            :
            <IconButton disabled={params?.row?.landDetailsOfGrowerResponsePojo[0]?.sendForDeleteDeactivate === "Y"}
              onClick={(e) => onDeleteMappedTransporter(e, params?.row, params?.row?.landDetailsOfGrowerResponsePojo[0])}
            >
              <DeleteIcon color={params?.row?.landDetailsOfGrowerResponsePojo[0]?.sendForDeleteDeactivate === "Y" ? 'disabled' : 'error'} fontSize='inherit' />
            </IconButton>
        )
      }
    },
  ]
  return (
    <>
      <Container maxWidth="xxl">
        {!PROD && <p className='pageNumberingResc'>RES05</p>}
        <Stack direction="row" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography variant="h5" gutterBottom>
            Grower-HIT Stakeholder Mapping
          </Typography>
        </Stack>
        <Card>
          <CardContent>
            <Grid container spacing={1}>
              <Grid item xs={12} lg={3}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.rescAlreadyMappedStakeholder}>
                  <InputLabel id="selectstakeholder-label">Select Stakeholder</InputLabel>
                  <Select
                    label="Select Stakeholder"
                    name="rescAlreadyMappedStakeholder"
                    value={details?.rescAlreadyMappedStakeholder || ''} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Select Stakeholder</em></MenuItem>
                    {
                      chooseMappedStakeholder.map((mappeduser) =>
                        <MenuItem key={mappeduser} value={mappeduser}>{mappeduser}</MenuItem>)
                    }
                  </Select>
                  <FormHelperText>{errorMessage?.choosestakeholderError}</FormHelperText>
                </FormControl>
              </Grid>
              {showList && <Grid item xs={12} lg={3}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.resMappedURN}>
                  <InputLabel id="mappedstakeholder-label">{details.rescAlreadyMappedStakeholder}</InputLabel>
                  <Select
                    label={details.rescAlreadyMappedStakeholder}
                    name="resMappedTypeName" value={(details.resMappedName + '*' + details.resMappedURN) || ''} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Mapped Stakeholder</em></MenuItem>
                    {selectedStakeHolderDetails.map((maapedtoname) =>
                      <MenuItem value={maapedtoname.stakeholderName + '*' + maapedtoname.urn}>{maapedtoname?.stakeholderName && titleCase(maapedtoname.stakeholderName)}({maapedtoname.urn})</MenuItem>

                    )}
                  </Select>
                  <FormHelperText>{errorMessage?.stakeholderlistError}</FormHelperText>
                </FormControl>
              </Grid>}
              {showHITList && <Grid item xs={12} lg={3}>
                <FormControl sx={{ width: '100%', paddingRight: '3%' }} error={submit && !details.rescHitURN}>
                  <InputLabel id="hitname-label">HIT name</InputLabel>
                  <Select
                    label='HIT name'
                    name="selectHitName" value={details.rescHitName + '#' + details.rescHitURN} onChange={(e) => handleChange(e)}>
                    <MenuItem><em>Select Hit</em></MenuItem>
                    {getHitDetails.map((hitdetails) =>
                      <MenuItem value={hitdetails.stakeholderName + '#' + hitdetails.urn} >{hitdetails?.stakeholderName && titleCase(hitdetails.stakeholderName)}({hitdetails.urn})</MenuItem>
                    )}
                  </Select>
                  <FormHelperText>{errorMessage?.hitNameError}</FormHelperText>
                </FormControl>
              </Grid>}
              {showHITList && <Grid item xs={12} lg={3}>
                <Button endIcon={<ProceedIcon />} sx={{ minWidth: 100 }} className="RescProceed" variant="contained" onClick={(e) => onSubmitStakeholder(e)}>Proceed</Button>
              </Grid>}
            </Grid>
            {showRevinueList &&
              <Grid container spacing={1}>
                <Grid item xs={12} lg={3}>
                  <FormControl sx={{ width: '100%', paddingRight: '3%', mt: 2 }}>
                    <InputLabel id="mappedstakeholder-label">Revenue Circle</InputLabel>
                    <Select
                      label="Revenue Circle"
                      name="revenueCircleList" value={details.revenueCircleVal || ''} onChange={(e) => handleChange(e)}>
                      <MenuItem><em>Select Revenue Circle</em></MenuItem>
                      {
                        Array.from(new Set(getAllDetails.map(item => item?.landDetailsOfGrowerResponsePojo[0]?.revenueCircle))).map(revenueCircle => {
                          return <MenuItem value={revenueCircle}>{revenueCircle}</MenuItem>
                        })
                      }
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>}
            {showmappedTable && filteredResults ?
              <Grid container spacing={1} sx={{ mt: 3 }}>
                <Grid item xs={12} lg={12}>
                  <Box sx={{
                    height: 430, width: '100%', mt: 2,
                    '& .themeSuccess': {
                      backgroundColor: '#FFFFFF'
                    },
                    '& .themeFailure': {
                      backgroundColor: '#FF7F7F',
                      color: '#1a3e72',
                    },
                  }}>
                    {(filteredResults && filteredResults.length !== 0) ?
                      <DataGrid
                        rows={filteredResults}
                        columns={growerhitmapping}
                        pageSize={5}
                        rowsPerPageOptions={[5]}
                        getRowId={(row) => row?.id}
                        components={{
                          Toolbar: CustomDataGridToolbar,
                        }}
                        getCellClassName={(params) => {
                          console.log("failedMappingArr", failedMappingArr)
                          console.log("params?.row", params?.row)
                          return failedMappingArr?.find(findItem => findItem?.sourceGrowerLandId === params?.row?.landDetailsOfGrowerResponsePojo[0]?.id) ? 'themeFailure' : 'themeSuccess';
                        }}
                        componentsProps={{ toolbar: { rows: filteredResults, columns: growerhitmapping, fileName: "GrowerHitMappingList.xlsx" } }}
                      />
                      :
                      <Typography display='flex' alignItems="center" justifyContent="center" sx={{ fontWeight: "bold" }}>{NO_DATA_AVAILABLE}</Typography>
                    }
                  </Box>
                </Grid>
              </Grid>
              :
              <></>
            }
            <Box display='flex' justifyContent="flex-end">
              {showmappedTable && (multipleGrowerHitMappingDetails.length > 0) ?
                <Button sx={{ minWidth: 100, mt: 2 }} variant="contained" onClick={(e) => onSavedMappingStakeholder(e)}>Submit</Button>
                : null
              }
            </Box>
          </CardContent>
        </Card>
      </Container>
      <ConfirmationPopover onOpen={logConfirmModalOpen} specialMessage={message} onConfirm={onConfirmCallBack} onClose={onCancelBack} action={(updatedDetails.deactivestatus === "Y") ? "Deactive" : updatedDetails.deleteid ? "Delete" : "Active"} />
      <ConfirmationPopover onOpen={logConfirmModalOpenSubmit} onConfirm={onConfirmCallBackSubmit} onClose={onCancelBackSubmit} action="Submit" />
    </>
  );
}
export default GrowerHitMapping;
